import Azerbaijan from '../assets/flags/Azerbaijan.png';
import Kazakhstan from '../assets/flags/Kazakhstan.png';
import Kyrgyzstan from '../assets/flags/Kyrgyzstan.png';
import Turkey from '../assets/flags/Turkey.png';
import Uzbekistan from '../assets/flags/Uzbekistan.png';
import Hungary from '../assets/flags/Hungary.png';
import Turkmenistan from '../assets/flags/Turkmenistan.png';
import UnitedKingdom from '../assets/flags/United Kingdom.png';
import TRNC from '../assets/flags/Turkish Republic of Northern Cyprus.png';
import ECO from '../assets/flags/Economic Cooperation Organization (ECO).png';

export const FLAGS = {
  turkey: Turkey,
  azerbaijan: Azerbaijan,
  kazakhstan: Kazakhstan,
  kyrgyzstan: Kyrgyzstan,
  uzbekistan: Uzbekistan,
  hungary: Hungary,
  turkmenistan: Turkmenistan,
  trnc: TRNC,
  eco: ECO,
  // Dil seçeneği için - aynı bayrakları kullanıyoruz
  az: Azerbaijan,
  kk: Kazakhstan,
  ky: Kyrgyzstan,
  tr: Turkey,
  uz: Uzbekistan,
  en: UnitedKingdom, // İngilizce için ayrı bayrak eklenecek
};

export default FLAGS;
